var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "topfixed",
      staticStyle: { "font-size": "14px" },
      style:
        _vm.$route.path == "/type/index"
          ? "border-bottom:2px solid #ED1F1F"
          : ""
    },
    [
      _c(
        "div",
        { staticStyle: { height: "40px", "background-color": "#f5f5f5" } },
        [
          _c(
            "div",
            { staticClass: "contain-box", staticStyle: { display: "flex" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-right": "20px",
                    "line-height": "40px",
                    color: "#55575E",
                    "font-family": "PingFang SC",
                    "font-weight": "400",
                    "font-size": "12px"
                  }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  !_vm.userInfo.id
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "20px",
                            cursor: "pointer"
                          },
                          on: { click: _vm.toLogin }
                        },
                        [_vm._v("登录/注册")]
                      )
                    : _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "20px",
                            cursor: "pointer"
                          },
                          on: { click: _vm.logout }
                        },
                        [_vm._v("退出登录")]
                      )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    display: "flex",
                    "font-family": "PingFang SC",
                    "font-weight": "400",
                    "font-size": "12px",
                    color: "#55575E"
                  }
                },
                [
                  _c("div", { staticStyle: { flex: "1" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "justify-content": "end" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "line-height": "40px",
                            "margin-right": "10px"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              staticStyle: { "margin-right": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.selMenus("/home/index")
                                }
                              }
                            },
                            [_vm._v("大有网首页")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              staticStyle: { "margin-right": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({ path: "/car" })
                                }
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-shopping-cart-2",
                                staticStyle: {
                                  "margin-right": "5px",
                                  color: "#ED1F1F"
                                }
                              }),
                              _vm._v("购物车")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              staticStyle: { "margin-right": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    path: "/personal/myCollect"
                                  })
                                }
                              }
                            },
                            [_vm._v("收藏夹")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              on: { click: _vm.toUserInfo }
                            },
                            [_vm._v("个人中心")]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "contain-box",
          staticStyle: { height: "100px", "line-height": "100px" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "200px",
                    height: "100px",
                    display: "flex",
                    "align-items": "center"
                  },
                  on: {
                    click: function($event) {
                      return _vm.selMenus("/home/index")
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: {
                      cursor: "pointer",
                      width: "110px",
                      height: "58px"
                    },
                    attrs: { src: _vm.logo }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    width: "74%",
                    "padding-left": "25px"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "搜索商品..." },
                      on: {
                        change: function($event) {
                          return _vm.search(_vm.input)
                        }
                      },
                      model: {
                        value: _vm.input,
                        callback: function($$v) {
                          _vm.input = $$v
                        },
                        expression: "input"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append", icon: "el-icon-search" },
                          on: {
                            click: function($event) {
                              return _vm.search(_vm.input)
                            }
                          },
                          slot: "append"
                        },
                        [_vm._v("搜索")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "40px", color: "#000" } }, [
        _c(
          "div",
          {
            staticClass: "contain-box",
            staticStyle: { display: "flex", position: "relative" }
          },
          [
            _c(
              "div",
              { staticClass: "all-type bfe4", staticStyle: { width: "200px" } },
              [
                _c("div", { staticStyle: { color: "#FFFFFF" } }, [
                  _c("i", {
                    staticClass: "el-icon-s-operation",
                    staticStyle: {
                      "line-height": "40px",
                      "margin-left": "10px"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { "line-height": "40px", color: "#fff" } },
                    [_vm._v("全部商品分类")]
                  ),
                  _vm._v(" "),
                  _vm.routeUrl !== "/home/index"
                    ? _c(
                        "div",
                        {
                          staticClass: "big-menu",
                          staticStyle: {
                            position: "absolute",
                            "z-index": "2000"
                          }
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "scroll-none pr",
                                staticStyle: {
                                  width: "200px",
                                  "background-color": "#fff",
                                  height: "500px",
                                  overflow: "scroll"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {},
                                  _vm._l(_vm.listData, function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        class: {
                                          "category-active":
                                            _vm.active == index &&
                                            _vm.showChildren
                                        },
                                        staticStyle: {
                                          padding: "0 10px",
                                          height: "40px",
                                          "line-height": "40px",
                                          transition:
                                            "background-color .2s ease"
                                        },
                                        on: {
                                          mouseenter: function($event) {
                                            return _vm.enter(item, index)
                                          },
                                          mouseleave: _vm.leave
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "fenlei" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "category--lable-active",
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.typePage(
                                                    _vm.item1.categoryId
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(item.name) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showChildren
                              ? _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: !_vm.hover,
                                        expression: "!hover"
                                      }
                                    ],
                                    staticClass: "scroll-none",
                                    staticStyle: {
                                      width: "1200px",
                                      height: "500px",
                                      overflow: "scroll",
                                      "z-index": "80",
                                      border: "2px solid #ED1F1F"
                                    },
                                    attrs: {
                                      sytle: _vm.showChildren
                                        ? "border: 2px solid #ED1F1F;"
                                        : ""
                                    },
                                    on: {
                                      mouseenter: function($event) {
                                        return _vm.enter()
                                      },
                                      mouseleave: _vm.leave
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "background-color": "#ffffff"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { margin: "0 10px" } },
                                          _vm._l(_vm.subMenusOfHover, function(
                                            item1,
                                            index1
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index1,
                                                staticStyle: {
                                                  color: "#333",
                                                  "line-height": "30px",
                                                  padding: "10px 0"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "category--lable-active",
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.typePage(
                                                          item1.categoryId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(item1.name) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      flex: "1",
                                                      "margin-left": "20px"
                                                    }
                                                  },
                                                  _vm._l(
                                                    item1.children,
                                                    function(item2, index2) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index2,
                                                          staticClass:
                                                            "sub-menu category--lable-active",
                                                          staticStyle: {
                                                            margin: "0 10px",
                                                            display:
                                                              "inline-block"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.typePage(
                                                                item2.categoryId
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                item2.name
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.menus, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class:
                    "menu-index " +
                    (_vm.menuPath === item.path ? "menu-active" : ""),
                  staticStyle: { "line-height": "40px" },
                  on: {
                    click: function($event) {
                      return _vm.selMenu(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.pageName) + "\n      ")]
              )
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "top-title" }, [
      _vm._v("欢迎来到"),
      _c("span", {}, [_vm._v("大有网")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e0cd79e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e0cd79e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/top/index.vue
// module id = null
// module chunks = 